import { Tooltip_default } from "./chunk-EVASBM6N.js";
import { Tooltip_Trigger_default } from "./chunk-BYZFMKMA.js";

// src/components/Tooltip/index.ts
var TooltipComponent = Tooltip_default;
TooltipComponent.Trigger = Tooltip_Trigger_default;
TooltipComponent.Trigger.displayName = "Tooltip.Trigger";
export { TooltipComponent };